export const STAFF_ROLE_LABELS = {
  admin: 'Administrateur',
  super_admin: 'Administrateur',
  lead_ops: 'Référent Ops',
  ops: 'Opérateur',
  operateur: 'Opérateur',
  lead_field_ops: 'Référent Terrain',
  field_ops: 'Agent Terrain',
  lead_commercial: 'Référent Commercial',
  commercial: 'Commercial',
  finance: 'Finance',
  comptable: 'Comptable',
  auditeur: 'Auditeur',
};

export const USUAL_OPERATOR_ROLES = ['ops', 'lead_ops', 'operateur', 'admin', 'super_admin'];
export const USUAL_FIELD_OPS_ROLES = ['field_ops', 'lead_field_ops', 'admin', 'super_admin'];

export const staffRoleLabel = (role) => STAFF_ROLE_LABELS[(role || '').toLowerCase()] || role || 'Staff';

// Le poste (fonction dans l'entreprise) est indépendant du rôle (permissions).
export const staffPosition = (staff) =>
  staff?.jobTitle || 'Poste non renseigné';
